__turbopack_context__.v({
  "animated": "ai-loader-icon-module__eYW-hq__animated",
  "orbit": "ai-loader-icon-module__eYW-hq__orbit",
  "orbitCcw": "ai-loader-icon-module__eYW-hq__orbitCcw",
  "orbitCcwSpin": "ai-loader-icon-module__eYW-hq__orbitCcwSpin",
  "orbitCw": "ai-loader-icon-module__eYW-hq__orbitCw",
  "orbitCwSpin": "ai-loader-icon-module__eYW-hq__orbitCwSpin",
  "orbitFaint": "ai-loader-icon-module__eYW-hq__orbitFaint",
  "static": "ai-loader-icon-module__eYW-hq__static",
  "twinkle": "ai-loader-icon-module__eYW-hq__twinkle",
  "twinkleA": "ai-loader-icon-module__eYW-hq__twinkleA",
  "twinkleB": "ai-loader-icon-module__eYW-hq__twinkleB",
  "twinklePulse": "ai-loader-icon-module__eYW-hq__twinklePulse",
});
